module.exports = __webpack_public_path__ + "static/media/dislike_inactive.bb62aca7.svg";